import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
// import { SetConditionalVariablesActionPayload } from '../actions';
import { DocumentTemplateStore } from '../types';

export const variablesSlice = {
  setConditionalVariables: (
    state: DocumentTemplateStore,
    { payload }: PayloadAction<any>,
  ): DocumentTemplateStore => {
    const { variableId, formValues, templateId } = payload;

    const path = `${templateId}.template.templateMeta.conditionalVariables`;
    const _payload = { formValues } as any;

    return dotPropImmutable.merge(state, path, { [variableId]: _payload });
  },

  removeConditionalVariables: (
    state: DocumentTemplateStore,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { payload }: PayloadAction<any>,
  ): DocumentTemplateStore => {
    // const { variableId } = payload;
    // const path = `data.${state.activeId}.template.templateMeta.conditionalVariables.${variableId}`;

    /**
     * TODO: mark the variable as deleted
     * and unmark the same on undo
     * and on template save, delete the variables marked as deleted
     * before making API call.
     */
    return state;

    // return {
    //   ...state,
    //   ...dotPropImmutable.delete(state, path),
    // };
  },
};
